export default "__VITE_PUBLIC_ASSET__ba4fe69e__"